import React, {useEffect, useState} from 'react';
import './LeadAllocation.scss';
import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";
import {toast} from "react-toastify";
import Loader from "../../../Loader";
import {ArrowIcon} from "../ExportIcons/ExportIcons";
import DynaSelectBox from "../../DynaView/DynaSelectBox";
import DynaInput from "../../DynaView/DynaInput";
import {useNavigate} from "react-router-dom";

const LeadAllocation = () => {

  const navigateTo = useNavigate();
  const [initialData, setInitialData] = useState({
    marketers: [],
    leadGroups: []
  });
  const [isLoad, setIsLoad] = useState(false);
  const [sendData, setSendData] = useState({
    group: "",
    count: "",
    countFreeLead: "",
    marketerIds: "",
    allCount: "",
  })

  const getInitialData = async () => {
    setIsLoad(false)
    const response = await _axios.get(prefixUrl() + "/hiSite/?request=leadAllocationInitialData")
    if (response?.data?.status) {
      setInitialData(response.data.data)
      setIsLoad(true)
    } else {
      toast.error(response.data.message)
    }
  }

  useEffect(() => {
    void getInitialData()
  }, []);

  const marketerHandler = (e, data) => {
    let temp = [...initialData?.marketers]
    temp.forEach((marketer) => {
      if (marketer.value === data.value) {
        marketer.checked = e.target.checked === true ? 1 : 0
      }
    })
    setInitialData({...initialData, marketers: temp})
  }

  const submitDataHandler = async () => {
    if (sendData?.group === "") {
      return toast.error("گروه را انتخاب کنید")
    }
    let temp = []
    initialData?.marketers.forEach((marketer) => {
      if (+marketer.checked === 1) {
        temp.push(marketer.value)
      }
    })
    if (temp.length === 0) {
      return toast.error("بازاریابی انتخاب نشده است")
    }
    if (sendData?.count === "") {
      return toast.error("تعداد تخصیص به هر بازاریاب را وارد کنید")
    }
    const formData = new FormData()
    formData.append('group', sendData?.group);
    formData.append('count', sendData?.count);
    temp.forEach((item, index) => {
      formData.append(`marketerIds[${index}]`, item);
    });
    const response = await _axios.post(prefixUrl() + "/hiSite/?request=leadAllocation", formData)
    if (response.data?.status) {
      toast.success(response?.data?.message)
      navigateTo(-1)
    } else {
      toast.error(response?.data?.message)
    }
  }

  useEffect(() => {
    if (initialData?.marketers.length > 0) {
      const checkedCount = initialData?.marketers.filter(item => +item.checked === 1).length;
      const calculatedValue = checkedCount * +sendData.count;
      setSendData(prevState => ({...prevState, allCount: calculatedValue}));
    }
  }, [initialData?.marketers, sendData?.count]);

  try {
    return (
      <>
        {isLoad ?
          <section className={"LeadAllocation"}>
            <section className={"parent-section"}>
              <div className={"title-side"}>
                <ArrowIcon/>
                <h5>گروه</h5>
              </div>
              <div className={"form-side"}>
                <DynaSelectBox options={initialData?.leadGroups}
                               hasFilter={false}
                               label={"انتخاب گروه"}
                               className={"solid-dyna-input"}
                               value={sendData?.group}
                               onChange={(data) => setSendData({
                                 ...sendData,
                                 group: data.value,
                                 countFreeLead: data.count,
                               })}
                />
                <DynaInput label={"تعداد لید های آزاد"}
                           name={"countFreeLead"}
                           className={"solid-dyna-input"}
                           placeholder={"تعداد لید های آزاد"}
                           value={sendData?.countFreeLead}
                           type={"text"}
                           disabled
                />
              </div>

              <div className={"title-side"}>
                <ArrowIcon/>
                <h5>انتخاب بازاریاب</h5>
              </div>
              <div className={"form-side"} style={{gridTemplateColumns: "repeat(3, 1fr)"}}>
                {initialData?.marketers.length > 0 && initialData?.marketers.map((item, index) =>
                  <label className="radio-label" key={"mk" + index}>
                    <input
                      type="checkbox"
                      name="marketers"
                      checked={+item?.checked === 1}
                      onChange={(e) => marketerHandler(e, item)}
                    />
                    <span className="custom-checkbox"></span>
                    {item?.label}
                  </label>
                )}
              </div>

              <div className={"title-side"}>
                <ArrowIcon/>
                <h5>تعداد تخصیص لید</h5>
              </div>
              <div className={"form-side"}>
                <DynaInput label={"تعداد تخصیص به هر بازاریاب"}
                           name={"count"}
                           className={"solid-dyna-input"}
                           placeholder={"تعداد تخصیص به هر بازاریاب را وارد کنید"}
                           value={sendData?.count}
                           type={"number"}
                           setDataFromComponent={(data) => {
                             setSendData({...sendData, ...data})
                           }}
                />
                <DynaInput label={"تعداد کل لید های تخصیص داده شده"}
                           name={"count"}
                           className={"solid-dyna-input"}
                           placeholder={"تعداد کل لید های تخصیص داده شده"}
                           value={sendData?.allCount}
                           type={"text"}
                           disabled
                />
              </div>
            </section>
            <section className={"button-side"}>
              <button onClick={submitDataHandler}>ثبت</button>
              <button className={"cansel-button"} onClick={() => navigateTo(-1)}>انصراف</button>
            </section>
          </section> : <Loader/>}
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default LeadAllocation;